export const CENTRAL_CCD_ROLE = 'CentralCCD.Approver';

function normalizeId(value) {
  return String(value || '').trim().toLowerCase();
}

export function effectiveAccessEntries(roleAssignments = [], ccdApprovers = []) {
  const entries = [...(Array.isArray(roleAssignments) ? roleAssignments : [])];
  for (const approver of Array.isArray(ccdApprovers) ? ccdApprovers : []) {
    const email = String(approver?.email || '').trim().toLowerCase();
    const objectId = String(approver?.objectId || '').trim();
    if (!email && !objectId) continue;
    entries.push({
      id: objectId || `central-ccd:${email}`,
      name: approver?.name || email || 'Central CCD approver',
      email,
      principalType: 'User',
      role: CENTRAL_CCD_ROLE,
      roleEnabled: true,
      source: 'central-ccd',
    });
  }
  return entries.sort((left, right) => {
    const nameCompare = String(left.name || left.email || '').localeCompare(String(right.name || right.email || ''));
    if (nameCompare) return nameCompare;
    const idCompare = normalizeId(left.id).localeCompare(normalizeId(right.id));
    return idCompare || String(left.role || '').localeCompare(String(right.role || ''));
  });
}

export function effectivePrincipalCount(entries = []) {
  const ids = new Set();
  for (const entry of entries) {
    const key = normalizeId(entry?.id) || String(entry?.email || '').trim().toLowerCase();
    if (key) ids.add(key);
  }
  return ids.size;
}
